"use client";

import { Progress as ProgressPrimitive } from "@base-ui/react/progress";
import * as React from "react";

import { cn } from "@/utils/lib";
import { resolveClassName } from "@/utils/resolve-class-name";

const Progress = ({
  className,
  getValueLabel,
  indicatorClassName,
  ...props
}: React.ComponentProps<typeof ProgressPrimitive.Root> & {
  getValueLabel?: (value: number) => string;
  indicatorClassName?: string | ((state: unknown) => string | undefined);
}) => (
  <ProgressPrimitive.Root
    aria-valuetext={
      typeof props.value === "number" && getValueLabel
        ? getValueLabel(props.value)
        : undefined
    }
    className={(state) =>
      cn("flex w-full flex-col gap-0", resolveClassName(className, state))
    }
    {...props}
  >
    <ProgressPrimitive.Track className="relative h-2 w-full overflow-hidden rounded-full bg-primary/20">
      <ProgressPrimitive.Indicator
        className={(state) =>
          cn(
            "h-full bg-primary transition-all",
            typeof indicatorClassName === "function"
              ? indicatorClassName(state)
              : indicatorClassName,
          )
        }
      />
    </ProgressPrimitive.Track>
  </ProgressPrimitive.Root>
);
Progress.displayName = "Progress";

export { Progress };
